var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.476,
    y1: -0.178,
    x2: 0.555,
    y2: 1.101,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.476,
    y1: -0.178,
    x2: 0.555,
    y2: 1.101,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5a505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#eaa804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#f8b301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.227,
    y1: -0.045,
    x2: 0.779,
    y2: 1.057,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coins",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    d: "M51.666,30H20v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(2.111 5.528)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    d: "M51.666,26H20v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(2.111 4.991)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M51.666,22H20v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(2.111 4.083)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M51.666,18H20v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(2.111 3.176)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M51.666,14H20v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(2.111 2.269)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M51.666,10H20v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(2.111 1.917)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 16,
    cy: 8,
    rx: 16,
    ry: 8,
    transform: "translate(22 4)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_425",
    "data-name": "Ellipse 425",
    cx: 12,
    cy: 5,
    rx: 12,
    ry: 5,
    transform: "translate(26 7)",
    fill: "#ffc800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M20,18.312v20.7c0,3.837,5.458,7.034,12.7,7.761a6.781,6.781,0,0,0,.491-2.483V28.456C33.194,23.5,27.794,19.548,20,18.312Z",
    transform: "translate(3.52 1.795)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M20,19.328V38.687c0,3.59,4.783,6.617,11.334,7.588a5.486,5.486,0,0,0,.541-2.31V28.131C31.875,23.949,26.957,20.5,20,19.328Z",
    transform: "translate(3.571 2.119)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M35.666,34H4v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(0 6.806)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M35.666,30H4v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(0 5.528)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M35.666,26H4v5.278c0,4.373,7.089,7.917,15.833,7.917s15.833-3.544,15.833-7.917Z",
    transform: "translate(0 4.991)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426",
    cx: 16,
    cy: 8,
    rx: 16,
    ry: 8,
    transform: "translate(4 23.414)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 12,
    cy: 5,
    rx: 12,
    ry: 5,
    transform: "translate(8 26.442)",
    fill: "#ffc800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.9a0f7b6a053fd3cc4b9b0aa98af77e19.svg";
export { ForwardRef as ReactComponent };